export default function getCurrentCulture() {
    if (document.documentElement.lang != null && document.documentElement.lang != "")
        return document.documentElement.lang;

    return window?.parent?.document?.documentElement?.lang || 'en-GB';
}

export function getAllApplicableCultures(culture: string): string[] {
    let matches = /([a-z]+)(?:-[A-Z]+)?/g.exec(culture);
    if (matches)
        return matches.map(c => c);
    else
        return [];
}

export function matchCultures(availableCultures: string[], desiredCulture: string): string|null {
    let cultures = getAllApplicableCultures(desiredCulture);
    for (let c of cultures) {
        let found = availableCultures.find(x => x === c);
        if (found)
            return found;
    }

    return null;
}

export function getClosestCulture(availableCultures: string[]): string|null {
    return matchCultures(availableCultures, getCurrentCulture());
}